import {
    useDispatchTrackEventWithLocation
} from '../../../../services/tracking/hooks/useDispatchTrackEventWithLocation';
import { Crm } from "../../../../domain/crm";

export const useSalesforceActivityTracking = () => {
    const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();

    const handleTrackManageCTAClick = (domain: string) => {
        dispatchTrackEventWithLocation('crm feed', 'click', `crm feed manage/${domain}`);
    };
    const handleTrackViewInSalesforce = () => {
        dispatchTrackEventWithLocation('company data', 'see company in CRM', `see in ${Crm.salesforce}`);
    };

    return {
        handleTrackViewInSalesforce,
        handleTrackManageCTAClick
    };
};
